<template>
    <section-layout class="section-steps d-flex justify-content-center">
        <div class="section-steps__content -pt-4 -pt-sm-12 col-sm-20">
            <p class="section-steps__title heading-48 text-center">Etapy programu:</p>

            <div class="section-steps__items d-flex flex-column mt-4">
                <div class="section-steps__item">
                    <p class="section-steps__title heading-32">ETAP I - ZGŁOSZENIE</p>
                    <p
                        class="section-steps__subtitle heading-20"
                    >Od 1 października do 31 października 2026 r.</p>
                    <div>
                        <div class="section-steps__text text-16">
                            <p
                                class="heading-16"
                            >Zgłoszenia utalentowanych uczniów przyjmowane są w trzech kategoriach:</p>
                            <ul class="-mb-0 d-flex flex-column list">
                                <li>nauki ścisłe (matematyka, informatyka, telekomunikacja, elektronika i elektrotechnika),</li>
                                <li>nauki przyrodnicze (astronomia, nauki biologiczne, fizyczne, chemiczne, nauki o Ziemi i środowisku np. geografia, geologia),</li>
                                <li>zaangażowanie społeczne (wolontariat).</li>
                            </ul>
                            <p
                                class="heading-16 form__pt-24"
                            >W każdej kategorii wyróżniamy dwie grupy:</p>
                            <ul class="-mb-0 d-flex flex-column list">
                                <li>uczniowie szkoły podstawowej (klasy VI-VIII)</li>
                                <li>uczniowie szkoły ponadpodstawowej (wszystkie klasy)</li>
                            </ul>
                            <p class="heading-16 form__pt-24 mb-1">Jak się zgłosić:</p>
                            <p>
                                W terminie od 1 października 2026 do 31 października 2026 r. należy wypełnić formularz aplikacyjny online
                                <span v-if="stageStatus != 2">.</span>
                                <span v-if="stageStatus == 2">
                                    ,
                                    dostępny
                                    <router-link :to="{ name: 'signUpStudent' }">TUTAJ</router-link>
                                </span>
                            </p>
                        </div>
                    </div>
                </div>

                <div class="section-steps__item">
                    <p class="section-steps__title heading-32">ETAP II - ZADANIE KONKURSOWE</p>
                    <p
                        class="section-steps__subtitle heading-20"
                    >Od 17 grudnia 2026 r. do 18 stycznia 2027 r.</p>
                    <div class="mb-5">
                        <div class="section-steps__text text-16">
                            <p
                                class="heading-16"
                            >Jury wybierze maksymalnie 105 najlepszych zgłoszeń w każdej z 3 kategorii (po 15 uczniów ze szkół podstawowych oraz po 20 uczniów ze szkół ponadpodstawowych).</p>
                            <p>Finaliści pierwszego etapu przygotują zadanie konkursowe — stworzą prezentację w formie video, w której przedstawią siebie oraz to, w jaki sposób przyznane stypendium wspomoże rozwój ich pasji i talentów.</p>
                            <p class="heading-16 -pt-2">Na tym etapie do zgłoszenia należy przygotować:</p>
                            <ul class="-mb-0 d-flex flex-column list">
                                <li>
                                    świadectwo ucznia za rok szkolny 2025/2026,
                                </li>
                                <li>
                                    dyplomy i inne dokumenty potwierdzające osiągnięcia ucznia i jego zaangażowanie w działalność społeczną w latach 2025-2026.
                                </li>
                            </ul>
                        </div>
                    </div>
                    <p class="color-blue heading-24 mb-3">Pliki do pobrania:</p>
                    <div>
                        <div class="section-steps__link-items">
                            <div class="section-steps__link-item">
                                <p
                                    class="heading-18 color-blue"
                                >Regulamin programu „Enea Akademia Talentów” dla uczniów</p>
                                <a
                                    href="EAT_Regulamin_Konkursu_Enea_Akademia_Talentow_2026_final.pdf"
                                    target="_blank"
                                    class="button__red"
                                >
                                    Pobierz
                                    <img
                                        src="@/assets/download-btn.svg"
                                        alt
                                        class="button__download"
                                    />
                                </a>
                            </div>
                            <div class="section-steps__link-item">
                                <p class="heading-18 color-blue">Materiały informacyjne</p>
                                <a
                                    href="EAT_Materialy_informacyjne.pdf"
                                    target="_blank"
                                    class="button__red"
                                >
                                    Pobierz
                                    <img
                                        src="@/assets/download-btn.svg"
                                        alt
                                        class="button__download"
                                    />
                                </a>
                            </div>
                            <div class="section-steps__link-item" v-if="stageStatus == 4">
                                <p
                                    class="heading-18 color-blue"
                                >Załączniki do zgłoszenia w II etapie</p>
                                <a
                                    href="Dokumennty_II_etap_2025.pdf"
                                    target="_blank"
                                    class="button__red"
                                >
                                    Pobierz
                                    <img
                                        src="@/assets/download-btn.svg"
                                        alt
                                        class="button__download"
                                    />
                                </a>
                            </div>
                            <div class="section-steps__link-item" v-if="stageStatus == 4">
                                <p class="heading-18 color-blue">
                                    Instrukcja dla uczniów jak przygotować się do drugiego
                                    etapu
                                </p>
                                <a
                                    href="ENEA_AT_VII_manual_2etap_11-2025.pdf"
                                    target="_blank"
                                    class="button__red"
                                >
                                    Pobierz
                                    <img
                                        src="@/assets/download-btn.svg"
                                        alt
                                        class="button__download"
                                    />
                                </a>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="section-steps__item">
                    <p class="section-steps__title heading-32">ETAP III — GŁOSOWANIE</p>
                    <p
                        class="section-steps__subtitle heading-20"
                    >Od 25 stycznia do 8 lutego 2027 r.</p>
                    <div>
                        <div class="section-steps__text text-16">
                            <p class="heading-16 section-steps__pb-16">
                                Na stronie Enea Akademia Talentów zostaną stworzone profile uczniów z prezentacją zadania konkursowego.
                            </p>
                            <p class="text-16">
                                Jury wybierze maksymalnie:
                                <ul>
                                    <li>po 10 zwycięzców w każdej kategorii ze szkół podstawowych,</li>
                                    <li>po 15 zwycięzców w kategoriach: nauki ścisłe i nauki przyrodnicze ze szkół ponadpodstawowych,</li>
                                    <li>14 zwycięzców z kategorii zaangażowanie społeczne ze szkół ponadpodstawowych,</li>
                                </ul>
                                którzy otrzymają stypendium.<br>
                                Dodatkowo internauci będą głosować na najciekawsze zgłoszenia. Uczniowie, którzy nie zostaną wybrani przez jury, a otrzymają najwyższą liczbę głosów w swojej kategorii, również zostaną nagrodzeni i otrzymają stypendia.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section-layout>
</template>

<script>
export default {
    data() {
        return {
            showModal: false,
            changeContent: true,
        };
    },
    methods: {
    },
    components: {
    },
    computed: {
        stageStatus() {
            return this.$store.state.stage
        }
    },
};
</script>
